import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useVehicles } from '../shared/context/vehicles/VehiclesContext'
import Navigation from './shared/navigation'
import { TooltipBoundaryContext } from '@/modules/drivers/context/TooltipBoundaryContext'
import clx from 'classnames'
import SideVehiclesTable from './components/SideVehiclesTable'
import { SideVehicleSelectionProvider } from './context/SideVehicleSelectionContext'
import { CollapsibleSidePanel } from '@/modules/shared/components'

type Props = {
  children: React.ReactNode
  companyId: string
  viewControlBar?: () => React.JSX.Element
  navigation?: boolean
  heightScreen?: boolean
  fullScreen?: boolean
  hideSidePanel?: boolean
}

export const VehiclesLayout = ({
  children,
  companyId,
  navigation = false,
  viewControlBar: ViewControlBar,
  heightScreen = false,
  fullScreen = false,
  hideSidePanel = false,
}: Props) => {
  const { t } = useLocalize()
  const { selectedVehicleId } = useVehicles()
  const baseClasses = clx(
    'module-vehicle tw-flex tw-flex-[1] tw-text-content-base tw-bg-base-100 tw-min-w-0 tw-max-w-full tw-overflow-hidden',
    {
      'tw-h-screen': fullScreen,
      'tw-padding-4 tw-mt-1 tw-mb-1 tw-rounded-xl tw-border tw-border-base-300':
        !fullScreen,
      'tw-h-[calc(100vh-8px)]': !fullScreen,
    },
  )
  const boundaryRef = React.useRef<HTMLDivElement>(null)

  return (
    <TooltipBoundaryContext.Provider value={boundaryRef}>
      <div className={baseClasses} ref={boundaryRef}>
        <SideVehicleSelectionProvider>
          {!hideSidePanel && (
            <CollapsibleSidePanel
              className="tw-flex tw-w-fit tw-flex-shrink-0 tw-flex-col tw-overflow-hidden tw-border-r tw-border-base-300"
              drawerClassName="tw-w-[300px] tw-max-w-[85vw]"
            >
              <SideVehiclesTable companyId={companyId} />
            </CollapsibleSidePanel>
          )}
          <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-overflow-x-auto tw-overflow-y-hidden">
            <div className="tw-flex tw-min-h-0 tw-min-w-[900px] tw-flex-1 tw-flex-col">
            {ViewControlBar && <ViewControlBar />}
            <div className="tw-flex tw-min-h-0 tw-flex-1">
              <div className="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">
                {navigation && (
                  <Navigation
                    selectedVehicleId={selectedVehicleId}
                    companyId={companyId}
                  />
                )}
                <main
                  className={`tw-flex tw-h-full tw-w-full tw-flex-1 ${heightScreen ? 'tw-max-h-screen tw-flex-col tw-overflow-hidden' : ''} `}
                >
                  {children}
                </main>
              </div>
            </div>
            </div>
          </div>
        </SideVehicleSelectionProvider>
      </div>
    </TooltipBoundaryContext.Provider>
  )
}
